import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Guid, ProductSubscriptionSuccessFeeTier } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useSubscriptionSuccessFeeTiersQuery(
	dealGuid?: Guid | undefined,
	subscriptionGuid?: Guid | undefined,
	options?:
		| Omit<
				UseQueryOptions<ProductSubscriptionSuccessFeeTier[], unknown, ProductSubscriptionSuccessFeeTier[], any>,
				'queryKey' | 'queryFn'
		  >
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Deal.SubscriptionTiers(dealGuid, subscriptionGuid),
		() =>
			AxiosUtils.getResponseData<ProductSubscriptionSuccessFeeTier[]>(
				api.get(CerebroApiEndpoints.Deals.SuccessFeeTiers(dealGuid, subscriptionGuid))
			),
		options
	);
}
